<template>
  <div v-show="true" :class="getClassName">
    <input
      v-for="(item, index) in getHiddenInputsWithIds"
      :id="item.id"
      :key="index"
      type="hidden"
      :name="item.name"
      :value="item.value"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { usePersonalizeStore } from "@/stores/modules/personalize";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useQuoteStore } from "@/stores/modules/quote";

export default {
  computed: {
    ...mapState(useWebproductStore, ["getIsPersonalizationNewPage"]),
    ...mapState(usePersonalizeStore, [
      "getCustomizedProductId",
      "getCustomizedProductPqType"
    ]),
    ...mapState(useQuoteStore, ["getIsQuoteMode"]),
    getHiddenInputsWithIds: function () {
      let result = {};
      if (!this.getIsPersonalizationNewPage || this.getIsQuoteMode) {
        result = {
          customizedProductId: {
            id: "customizedProductId",
            name: "customizedProductId",
            value: this.getCustomizedProductId
          },
          customizedProductIdSaveFrame: {
            id: "customizedProductIdSaveFrame",
            name: "customizedProductIdSaveFrame",
            value: ""
          },
          pq_type: {
            id: "pq_type",
            name: "pq_type",
            value: this.getCustomizedProductPqType
          }
        };
      }
      return result;
    }
  }
};
</script>
